import {Component} from 'angular2/core';

@Component({
    selector: 'footer',
    templateUrl: './app/components/layout/footer/footer.html'
})
export class FooterComponent { }
